import React from 'react'
import { ArrowForward } from '@mui/icons-material'
import cn from '../../../../../lib/utils/cn'
import { useFormContext } from 'react-hook-form'
import { FormValues } from '../index'
import type { RegionalPlanProduct } from '../../../../../lib/api/types/pricing.interfaces'
import { getDisplayPriceForPeriod } from '../utils'
import { formatDecimal } from '../../../../../lib/utils/billing/formatter'

interface PlanPriceProps {
	plan: RegionalPlanProduct
	isActive: boolean
}

const PlanPrice: React.FC<PlanPriceProps> = ({ plan, isActive }) => {
	const { watch } = useFormContext<FormValues>()
	const period = watch('period')

	const monthAlternativePrice =
		getDisplayPriceForPeriod(plan, 'month') * 12
	const displayPrice = getDisplayPriceForPeriod(plan, period)
	const currencySymbol = plan.regionalPricing.symbol

	if (displayPrice == null) return null

	return (
		<div className="flex gap-3 w-full items-center h-9 box-border">
			<div className="flex gap-1 items-center">
				{period === 'year' && Boolean(monthAlternativePrice) && (
					<>
						<p className="text-text-secondary font-extrabold text-sm line-through">
							<span className="">
								{currencySymbol}
								{formatDecimal(monthAlternativePrice)}
							</span>
						</p>
						<ArrowForward className="w-4 h-4 text-accent" />
					</>
				)}
				<div
					className={cn(
						'relative flex justify-center text-text-secondary text-sm font-medium border border-accent rounded-md px-2.5 items-center h-9 box-border gap-0.5',
						isActive ? 'bg-white' : 'bg-accent-light',
					)}
				>
					<span className="font-extrabold text-sm">{currencySymbol}</span>
					<span className="text-text-main text-xl">
						{formatDecimal(displayPrice)}
					</span>
				</div>
			</div>
			<div className="flex gap-1 flex-nowrap">
				{Boolean(plan?.unitLabel?.trim()) && (
					<span className="px-1.5 py-0.5 tx bg-background-light dark:bg-background-dark border border-stroke-light dark:border-stroke-dark-dark rounded-md text-text-secondary dark:text-stroke-light text-xs font-light">
						per {plan.unitLabel.toLowerCase()}
					</span>
				)}
				<span className="px-1.5 py-0.5 bg-background-light dark:bg-background-dark border border-stroke-light dark:border-stroke-dark-dark rounded-md text-text-secondary dark:text-stroke-light text-xs font-light">
					per {period}
				</span>
			</div>
		</div>
	)
}

export default PlanPrice
